module.exports = __webpack_public_path__ + "img/home.a158caf2.svg";